module.exports = __webpack_public_path__ + "static/img/SA@3x.765a0712.jpg";